export default __webpack_public_path__ + "static/media/ITNAC.27570dfa.png";